<template>
  <div :class="$style[classes]" v-loading="loading">
     <pt-page-title title="存储报名详情"></pt-page-title>
     <pt-sub-title title="存储报名信息"></pt-sub-title>
      <table :class="$style['save-sign-detail']">
        <pt-message-table-item label="活动名称">
          {{data.eventName}}
        </pt-message-table-item>
         <pt-message-table-item v-for="(item,index) in fieldsArr" :label="item.label" :key="index">
           {{itemData(genericFormData,item)}}
          <!-- {{data[item.key]}} -->
        </pt-message-table-item>
        <template v-if="signDetail.existsOptions">
        <pt-message-table-item :label="signDetail.optionName">
            {{userOption.remark?userOption.remark:"--"}}
          </pt-message-table-item>
          <pt-message-table-item label="定金" v-if="data.userOption&&data.userOption.deposit">
            {{data.promotion_amount?data.promotion_amount:"--"}}
          </pt-message-table-item>
        </template>
        <pt-message-table-item label="预约时间">
           {{data.registration_time}}
        </pt-message-table-item>
        <pt-message-table-item label="预约状态">
          {{data.sign_status}}
        </pt-message-table-item>
        <template v-if="data.status==='CANCEL'">
      <pt-message-table-item label="取消操作员">
        {{(data.operationalInformation && data.operationalInformation.name)||'--'}}
      </pt-message-table-item>
      <pt-message-table-item label="取消时间">
        {{data.cancel_time||'--'}}
      </pt-message-table-item>
      <pt-message-table-item label="取消原因">
        {{data.canCellReason||'--'}}
      </pt-message-table-item>
      </template>
      </table>
      <div class="button-div" v-if="isShowCancel">
          <el-button type="primary" @click="cancelSign" :loading="cancelLoading">取消预约</el-button>
          <!-- <el-button type="primary" @click="editSignOrder" v-if="showEditButton">编辑</el-button> -->
          <el-button type="primary" plain @click="getOrderDetail" v-if="showOrderButton">查看订单</el-button>
      </div>
  <el-dialog :visible.sync="is_dialog" width="30%" @close="closeDialog" title="编辑报名地区信息">
    <health-message-edit :genericFormData="genericFormData" :registrationId="id"  v-if="is_edit" @closeDialog="closeDialog" :mallOrderId="data.mallOrderId"></health-message-edit>
  </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import { itemFiledsData } from '../../utils-filed'
import healthMessageEdit from 'cps/goods-order/health-message-edit'
import { hasPermissions } from 'utils/permissions'
const PERM_REGISTRATION_CANCEL = 'PERM_REGISTRATION_CANCEL'// 是否有取消报名的权限
const PERM_MALL_ORDER_EDIT = 'PERM_MALL_ORDER_EDIT'// 是否拥有编辑地区的权限

const prefixCls = 'pt-save-sign-detail'
export default {
  name: 'pt-save-sign-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    genericFormData () {
      return (this.data.genericFormData && this.data.genericFormData && this.data.genericFormData.data) || {}
    },
    userOption () {
      return this.data.userOption || {}
    },
    fieldsArr () {
      return (this.signDetail && this.signDetail.form && this.signDetail.form.fields) || []
    },
    HAS_PERM_REGISTRATION_CANCEL () { // 是否有取消报名的权限
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_REGISTRATION_CANCEL)
    },
    // 是否显示取消按钮
    isShowCancel () {
      return this.HAS_PERM_REGISTRATION_CANCEL && this.data.status === 'SUCCESS'
    },
    is_dialog: {
      get: function () {
        return this.is_edit
      },
      set: function (val) {
        this.is_edit = val
      }
    },
    HAS_PERM_MALL_ORDER_EDIT () {
      return hasPermissions(this.$auth.user() && this.$auth.user().permissions, PERM_MALL_ORDER_EDIT)
    },
    showEditButton () {
      return this.HAS_PERM_MALL_ORDER_EDIT && this.data.mallOrderId
    },
    // 是否显示查看订单按钮
    showOrderButton () {
      return this.data.mallOrderId
    }
  },
  props: {
    id: {
      type: String
    },
    data: {
      type: Object
    },
    cancelLoading: {
      type: Boolean
    },
    signDetail: {
      type: Object
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    healthMessageEdit
  },
  data () {
    return {
      is_edit: false
    }
  },
  methods: {
    editSignOrder () {
      this.is_edit = true
    },
    closeDialog (val) {
      this.is_dialog = false
      if (val) {
        this.$emit('signNotesDetail')
      }
    },
    cancelSign () {
      this.$emit('cancelSign')
    },
    itemData (data, val) {
      return itemFiledsData(data, val)
    },
    getOrderDetail () {
      this.$router.push(`/mall-order-all/order-detail/${this.data.mallOrderId}/detail`)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.save-sign-detail{
  padding: 0 20px;
}
.pt-save-sign-detail{
  :global{
    .el-dialog{
      width: 50%;
      min-width: 450px;
    }
  }
}
</style>
